import { AbstractControl, UntypedFormControl, ValidatorFn, Validators } from '@angular/forms';
import _has from 'lodash-es/has';
import { FieldValidators, FormControlOptions, FormField, FormFieldSerializedValue } from '../form-field';
import { backendApiValidator } from '../backend-api-validator';

export class BaseControl {
  constructor(protected field: FormField, protected options: FormControlOptions = {}) {}

  createFormControl(): UntypedFormControl {
    return new UntypedFormControl(this.unserializeValue(), {
      validators: this.createValidators(),
      ...this.getOptions(),
    });
  }

  updateFormControlValue(formControl: AbstractControl): void {
    formControl.patchValue(this.unserializeValue());
  }

  unserializeValue(): any {
    return this.field.value;
  }

  serializeValue(formControlValue: any): FormFieldSerializedValue {
    return formControlValue;
  }

  getValidatorConstraint(validatorName: keyof FieldValidators): any {
    if (!this.hasValidator(validatorName)) {
      return;
    }

    return this.getValidators()[validatorName];
  }

  protected hasValidator(name: keyof FieldValidators): boolean {
    return _has(this.getValidators(), name);
  }

  protected getValidators(): FieldValidators {
    return this.field.validators || {};
  }

  protected getKnownValidators(): { [key: string]: (...args: any[]) => ValidatorFn } {
    return {};
  }

  protected getOptions(): { updateOn?: 'change' | 'blur' | 'submit' } {
    return {};
  }

  private createValidators(): ValidatorFn[] {
    if (!this.field.validators) {
      return [backendApiValidator];
    }

    const knownValidators = {
      required: () => Validators.required,
      ...this.getKnownValidators(),
    };

    const fieldValidators = Object.entries(this.getValidators()).map(([validator, constraint]) => {
      if (_has(knownValidators, validator)) {
        if (validator === 'required' && !constraint) {
          return Validators.nullValidator;
        }

        return knownValidators[validator](constraint);
      }

      return Validators.nullValidator;
    });

    return [backendApiValidator, ...fieldValidators];
  }
}
